// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    scroll-behavior: smooth;
}
body {
    overflow: hidden;
}
h2 {
    font-family: 'Lily Script One', cursive;
}
p {
    font-family: 'Literata', serif;
}
.pageOne {
    height: 100vh;
    width: 100%;
    background-color: black;
    text-align: center;
}
.pageOne:before {
    display: inline-block;
    vertical-align: middle;
    height: 100%;
    content: " "
}
.pageOne > img {
    width: 100%;
    display: inline-block;
    vertical-align: middle;

}
#pageOne .fas, #pageOne .fas-angle-double-down, .pageOne .fas-angle-double-down:visited {
    color: black;
    margin-top: 90%;
    position: fixed;
    bottom: 0px;
    left: calc(50vw - 25px);
    font-size: 5em;
    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: white;
}
#pageOne .fas:hover, #pageOne .fas-angle-double-down:hover {
    text-shadow: 0 0 20px white;
}
.mainPage {
    width: 100%;
    height: 100vh;
    transform: translateZ( 0 );
    transition: transform 0.8s ease-in-out;
    backface-visibility: hidden;
    background-color: black;
}
.news,.about,.gallery,.order {
    color: white;
    overflow-y: auto;
    overflow-x: hidden;
    position: absolute;
    top: 153px;
    bottom: 40px;
    width: 100%;
    background-image: none;

}
.header {
    width: 100%;
    padding-top: 5px;
    position: absolute;
    top: 0;
}
.header button {
    color: white;
    font-size: 1.5rem;
    line-height: 30px;
    height: 30px;
    padding: 0px;
    text-align: center;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1.5em;
    padding-left: 16px;
    font-family: 'Literata', serif;
}
.pageOne button {
    border: none;
    background: none;
}
.nav {
    width: 100%;
    background-color: #66ADDD;
    height: 30px;
}
.mini-img {
    height: 100px;
    width: auto;
    display: block;
    margin: auto;
}
.nav-item {
    margin-right: 20px;
    height: 30px;
    text-align: center;
    padding-top: 0;
}
.nav-item > .nav-link {
    color: white;
    font-size: 1.5rem;
    font-family: 'Literata', serif;
    padding-top: 0px;
    line-height: 30px;

}
.nav-link:hover {
    color: #085DB6;
}
.nav-link:active {
    color: gray !important;
}
.i, .fab, .fa, .fas {
    color: white;
}
.footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 40px; /* Set the fixed height of the footer here */
    line-height: 40px; /* Vertically center the text there */
    color: white;
    text-align: center;
    font-weight: 400;
    background-color: #66ADDD;
    font-weight: lighter;
    z-index: 1;
}

.naked:hover {
    color: #085DB6;
}
.modal p, .modal .fas, .modal .fa, .modal i, .modal a {
    background-color: #3d3d3d;
    color: #66ADDD;
    border: none;
    text-decoration: none;
}
.largePic {
    display: block;
    max-width: 100%;
    height: auto;
    width: 55%;
    justify-content: center;
    border-radius: 7px;
}
.bioPic {
    display: block;
    max-width: 100%;
    height: auto;
    width: 90%;
    justify-content: center;
    border-radius: 7px;
    box-shadow: 0 0 80px black;
}
.pic {
    border-right: thick solid #66ADDD;
    height: 100%;
}
.bio {
    font-size: 1.5rem;
    background-color: rgb(0, 0, 0, 0.5) !important;
    background-color: black;
    margin-right: 20px !important;
    margin-left: 20px !important;
    height: 100%;
    box-shadow: 0px 0px 30px black;
}
.carousel,.carousel-slider {
    max-width: 40%;
    margin: auto !important;
}
.order1, .order2, .order3, .jotform {
    width: 90%;
    text-align: center !important;
    margin: auto !important;
}
.order1, .order3, .order3 a, .order1 p, .order3 p {
    font-size: 3rem;
    color: #8AEDEA;
    text-decoration: none;
    font-family: 'Literata', serif;
}
.order2, .order2 p {
    font-size: 6rem;
    color: #66ADDD;
    font-family: 'Lily Script One', cursive;
}
.ordering {
    background-color: black;
    background: rgb(0, 0, 0, 0.5);
    box-shadow: 0 0 30px black;
}

@media only screen and (max-width: 600px) { 
    .nav-item {
        margin-right: 5px;
    }
}
@media only screen and (max-width: 600px) {
    .header button {
        font-size: 1rem;
    }
    .nav-item > .nav-link {
        font-size: 1rem;
    }
    .largePic {
        width: 100%;
    }
    .mini-img {
        height: 75px;
    }
    .news,.about,.gallery,.order {
        top: 130px;
    }
    .gallery {
        width: 100%;
    }
    .aboutDiv {
        max-width: 100%;
    }
    .carousel,.carousel-slider {
        max-width: 100%;
        margin: auto !important;
    }
    .pic {
        width: 75%;
        border-right: none;
    }
    .bio {
        font-size: 1rem;
        margin-right: 10px !important;
        margin-left: 10px !important;
    }
    .order1 p, .order3 a, .order3 p {
        font-size: 2rem;
    }
    .order2 p {
        font-size: 4rem;
    }
}
@media only screen and (min-width: 601px) and (max-width: 800px) {

    .largePic {
        width: 100%;
    }
    .mini-img {
        height: 100px;
    }
    .news,.about,.gallery,.order {
        top: 155px;
    }
    .gallery {
        width: 100%;
    }
    .aboutDiv {
        max-width: 100%;
        width: 100%;
    }
    .carousel,.carousel-slider {
        max-width: 100%;
        margin: auto !important;
    }
    .pic {
        width: 75%;
        border-right: none;
    }
    .bio {
        font-size: 1rem;
        margin-right: 10px !important;
        margin-left: 10px !important;
    }
}
@media only screen and (min-width: 801px) and (max-width: 1100px) {

    .mini-img {
        height: 100px;
        
    }
    .news,.about,.gallery,.order {
        top: 155px;
    }
    .gallery {
        width: 100%;
    }
    .aboutDiv {
        max-width: 100%;
        width: 100%;
    }
    .carousel,.carousel-slider {
        max-width: 100%;
        margin: auto !important;
    }
    .pic {
        width: 75%;
        border-right: none;
    }
    .bio {
        font-size: 1rem;
        margin-right: 10px !important;
        margin-left: 10px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,uCAAuC;AAC3C;AACA;IACI,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,YAAY;IACZ;AACJ;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,sBAAsB;;AAE1B;AACA;IACI,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,uBAAuB;IACvB,cAAc;IACd,8BAA8B;IAC9B,gCAAgC;AACpC;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,aAAa;IAEb,0BAA0B;IAE1B,sCAAsC;IAEtC,2BAA2B;IAC3B,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,sBAAsB;;AAE1B;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;AACV;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;AAClC;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,aAAa;IACb,WAAW;IACX,cAAc;IACd,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,8BAA8B;IAC9B,gBAAgB;IAChB,iBAAiB;;AAErB;AACA;IACI,cAAc;AAClB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY,EAAE,4CAA4C;IAC1D,iBAAiB,EAAE,qCAAqC;IACxD,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,eAAe;IACf,YAAY;IACZ,UAAU;IACV,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,eAAe;IACf,YAAY;IACZ,UAAU;IACV,uBAAuB;IACvB,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,iCAAiC;IACjC,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,8CAA8C;IAC9C,uBAAuB;IACvB,6BAA6B;IAC7B,4BAA4B;IAC5B,YAAY;IACZ,8BAA8B;AAClC;AACA;IACI,cAAc;IACd,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,6BAA6B;IAC7B,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,8BAA8B;AAClC;AACA;IACI,eAAe;IACf,cAAc;IACd,uCAAuC;AAC3C;AACA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;IAChB;IACA;QACI,UAAU;IACd;IACA;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,uBAAuB;IAC3B;IACA;QACI,UAAU;QACV,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,6BAA6B;QAC7B,4BAA4B;IAChC;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;AACA;;IAEI;QACI,WAAW;IACf;IACA;QACI,aAAa;IACjB;IACA;QACI,UAAU;IACd;IACA;QACI,WAAW;IACf;IACA;QACI,eAAe;QACf,WAAW;IACf;IACA;QACI,eAAe;QACf,uBAAuB;IAC3B;IACA;QACI,UAAU;QACV,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,6BAA6B;QAC7B,4BAA4B;IAChC;AACJ;AACA;;IAEI;QACI,aAAa;;IAEjB;IACA;QACI,UAAU;IACd;IACA;QACI,WAAW;IACf;IACA;QACI,eAAe;QACf,WAAW;IACf;IACA;QACI,eAAe;QACf,uBAAuB;IAC3B;IACA;QACI,UAAU;QACV,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,6BAA6B;QAC7B,4BAA4B;IAChC;AACJ","sourcesContent":["html {\n    scroll-behavior: smooth;\n}\nbody {\n    overflow: hidden;\n}\nh2 {\n    font-family: 'Lily Script One', cursive;\n}\np {\n    font-family: 'Literata', serif;\n}\n.pageOne {\n    height: 100vh;\n    width: 100%;\n    background-color: black;\n    text-align: center;\n}\n.pageOne:before {\n    display: inline-block;\n    vertical-align: middle;\n    height: 100%;\n    content: \" \"\n}\n.pageOne > img {\n    width: 100%;\n    display: inline-block;\n    vertical-align: middle;\n\n}\n#pageOne .fas, #pageOne .fas-angle-double-down, .pageOne .fas-angle-double-down:visited {\n    color: black;\n    margin-top: 90%;\n    position: fixed;\n    bottom: 0px;\n    left: calc(50vw - 25px);\n    font-size: 5em;\n    -webkit-text-stroke-width: 1px;\n    -webkit-text-stroke-color: white;\n}\n#pageOne .fas:hover, #pageOne .fas-angle-double-down:hover {\n    text-shadow: 0 0 20px white;\n}\n.mainPage {\n    width: 100%;\n    height: 100vh;\n    -webkit-transform: translateZ( 0 );\n    transform: translateZ( 0 );\n    -webkit-transition: -webkit-transform 0.8s ease-in-out;\n    transition: transform 0.8s ease-in-out;\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    background-color: black;\n}\n.news,.about,.gallery,.order {\n    color: white;\n    overflow-y: auto;\n    overflow-x: hidden;\n    position: absolute;\n    top: 153px;\n    bottom: 40px;\n    width: 100%;\n    background-image: none;\n\n}\n.header {\n    width: 100%;\n    padding-top: 5px;\n    position: absolute;\n    top: 0;\n}\n.header button {\n    color: white;\n    font-size: 1.5rem;\n    line-height: 30px;\n    height: 30px;\n    padding: 0px;\n    text-align: center;\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 1.5em;\n    padding-left: 16px;\n    font-family: 'Literata', serif;\n}\n.pageOne button {\n    border: none;\n    background: none;\n}\n.nav {\n    width: 100%;\n    background-color: #66ADDD;\n    height: 30px;\n}\n.mini-img {\n    height: 100px;\n    width: auto;\n    display: block;\n    margin: auto;\n}\n.nav-item {\n    margin-right: 20px;\n    height: 30px;\n    text-align: center;\n    padding-top: 0;\n}\n.nav-item > .nav-link {\n    color: white;\n    font-size: 1.5rem;\n    font-family: 'Literata', serif;\n    padding-top: 0px;\n    line-height: 30px;\n\n}\n.nav-link:hover {\n    color: #085DB6;\n}\n.nav-link:active {\n    color: gray !important;\n}\n.i, .fab, .fa, .fas {\n    color: white;\n}\n.footer {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    height: 40px; /* Set the fixed height of the footer here */\n    line-height: 40px; /* Vertically center the text there */\n    color: white;\n    text-align: center;\n    font-weight: 400;\n    background-color: #66ADDD;\n    font-weight: lighter;\n    z-index: 1;\n}\n\n.naked:hover {\n    color: #085DB6;\n}\n.modal p, .modal .fas, .modal .fa, .modal i, .modal a {\n    background-color: #3d3d3d;\n    color: #66ADDD;\n    border: none;\n    text-decoration: none;\n}\n.largePic {\n    display: block;\n    max-width: 100%;\n    height: auto;\n    width: 55%;\n    justify-content: center;\n    border-radius: 7px;\n}\n.bioPic {\n    display: block;\n    max-width: 100%;\n    height: auto;\n    width: 90%;\n    justify-content: center;\n    border-radius: 7px;\n    box-shadow: 0 0 80px black;\n}\n.pic {\n    border-right: thick solid #66ADDD;\n    height: 100%;\n}\n.bio {\n    font-size: 1.5rem;\n    background-color: rgb(0, 0, 0, 0.5) !important;\n    background-color: black;\n    margin-right: 20px !important;\n    margin-left: 20px !important;\n    height: 100%;\n    box-shadow: 0px 0px 30px black;\n}\n.carousel,.carousel-slider {\n    max-width: 40%;\n    margin: auto !important;\n}\n.order1, .order2, .order3, .jotform {\n    width: 90%;\n    text-align: center !important;\n    margin: auto !important;\n}\n.order1, .order3, .order3 a, .order1 p, .order3 p {\n    font-size: 3rem;\n    color: #8AEDEA;\n    text-decoration: none;\n    font-family: 'Literata', serif;\n}\n.order2, .order2 p {\n    font-size: 6rem;\n    color: #66ADDD;\n    font-family: 'Lily Script One', cursive;\n}\n.ordering {\n    background-color: black;\n    background: rgb(0, 0, 0, 0.5);\n    box-shadow: 0 0 30px black;\n}\n\n@media only screen and (max-width: 600px) { \n    .nav-item {\n        margin-right: 5px;\n    }\n}\n@media only screen and (max-width: 600px) {\n    .header button {\n        font-size: 1rem;\n    }\n    .nav-item > .nav-link {\n        font-size: 1rem;\n    }\n    .largePic {\n        width: 100%;\n    }\n    .mini-img {\n        height: 75px;\n    }\n    .news,.about,.gallery,.order {\n        top: 130px;\n    }\n    .gallery {\n        width: 100%;\n    }\n    .aboutDiv {\n        max-width: 100%;\n    }\n    .carousel,.carousel-slider {\n        max-width: 100%;\n        margin: auto !important;\n    }\n    .pic {\n        width: 75%;\n        border-right: none;\n    }\n    .bio {\n        font-size: 1rem;\n        margin-right: 10px !important;\n        margin-left: 10px !important;\n    }\n    .order1 p, .order3 a, .order3 p {\n        font-size: 2rem;\n    }\n    .order2 p {\n        font-size: 4rem;\n    }\n}\n@media only screen and (min-width: 601px) and (max-width: 800px) {\n\n    .largePic {\n        width: 100%;\n    }\n    .mini-img {\n        height: 100px;\n    }\n    .news,.about,.gallery,.order {\n        top: 155px;\n    }\n    .gallery {\n        width: 100%;\n    }\n    .aboutDiv {\n        max-width: 100%;\n        width: 100%;\n    }\n    .carousel,.carousel-slider {\n        max-width: 100%;\n        margin: auto !important;\n    }\n    .pic {\n        width: 75%;\n        border-right: none;\n    }\n    .bio {\n        font-size: 1rem;\n        margin-right: 10px !important;\n        margin-left: 10px !important;\n    }\n}\n@media only screen and (min-width: 801px) and (max-width: 1100px) {\n\n    .mini-img {\n        height: 100px;\n        \n    }\n    .news,.about,.gallery,.order {\n        top: 155px;\n    }\n    .gallery {\n        width: 100%;\n    }\n    .aboutDiv {\n        max-width: 100%;\n        width: 100%;\n    }\n    .carousel,.carousel-slider {\n        max-width: 100%;\n        margin: auto !important;\n    }\n    .pic {\n        width: 75%;\n        border-right: none;\n    }\n    .bio {\n        font-size: 1rem;\n        margin-right: 10px !important;\n        margin-left: 10px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
